module.exports = __webpack_public_path__ + "img/hadiah-1.5jt.80445216.png";